import { NotificationBase } from './notification-base';

export class NotificationExpressionOfInterestExpired extends NotificationBase {
  process(): void {
    this.showAlert();
  }

  protected viewNotification(): void {
    this.navCtrl.navigateForward('/tabs/manage-clients/view-filtered-requests', {
      state: { clientRequestUuid: this.item.uuid },
    });
  }
}
